import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { PartsListService } from '../../../../components/parts-and-inventory/parts-list/pages/parts-list/parts-list.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-select-renderer',
  templateUrl: './select-renderer.component.html',
  styleUrls: ['./select-renderer.component.scss']
})
export class SelectRendererComponent implements OnInit,ICellRendererAngularComp {
  params;
  inputValue : string;
  constructor(public partsListService: PartsListService,public storageService:StorageService) { }
  list = [ {id:'1', name:'11'},{id:'2', name:'12'},{id:'3', name:'13'},{id:'4', name:'14'},{id:'5', name:'15'}]
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    const columnId = this.params.column.getId();
    if (['conditionId', 'cooId', 'rohsId','vendorContactId'].includes(columnId)) {
      let dropDown =   this.storageService.retrieve('PART_DROPDOWNLIST')
      switch (columnId) {
        case 'conditionId':
          this.list = dropDown?.inventoryConditionsList;
          break;
        case 'cooId':
          this.list = dropDown?.countryList;
          break;
        case 'rohsId':
          this.list = dropDown?.roHSList;
          break;
        case 'vendorContactId':
          if(this.params?.contactListShow){
          this.list = dropDown?.requestVendorContactList?.filter(x=>x.extra2 == this.params?.data?.vendorId);

          }
        break;
      }
}
    this.updateColumn(params)
  }
  updateColumn(params){
    if(params?.value){ 
      this.inputValue = params?.value
    }
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    this.params = params;
    return true;
  }

  ngOnInit(): void {
  }
  selected(value) {
    this.params.value = value;
    const columnId = this.params.column.getId();
    this.params.data[columnId] = value;
      this.params.api.refreshCells({ rowNodes: [this.params.node], force: true });
      const customEvent = new CustomEvent('selectOptionClick', {
        detail : { data: this.params },
      });
      document.dispatchEvent(customEvent);
  }
}
